import {
  Card,
  Box,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import Iconify from "../iconify/Iconify";
import { RatingTypes } from "src/utils/cardUtils";

export default function ScoreablesHeader({
  ratings,
  canTeamGenerate,
  handleUpdateTeamGenerate,
  team,
  handleChangeSelect,
  teams,
  handleSaveRatings,
  seasons,
  selectedSeason,
  handleSeasonChange,
}) {
  return (
    <Card style={{ marginBottom: 10 }}>
      <Box
        sx={{ display: "flex", justifyContent: "center" }}
        style={{ padding: 20, marginBottom: 10 }}
      >
        <FormControlLabel
          value="top"
          control={
            <Switch
              color="primary"
              checked={canTeamGenerate}
              onChange={handleUpdateTeamGenerate}
            />
          }
          label="Generate"
          labelPlacement="top"
        />
        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
          <InputLabel id="season-select-label">Season</InputLabel>
          <Select
            labelId="season-select-label"
            id="season-select"
            value={selectedSeason || ''}
            label="Season"
            onChange={handleSeasonChange}
          >
            {seasons.map((season) => (
              <MenuItem value={season.seasonId} key={season.seasonId}>
                {season.displayName} {season.isCurrentSeason && '(Current)'}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 350 }} size="small">
          <InputLabel id="select-label">
            {ratings ? "Rating" : "Team"}
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={team}
            label={ratings ? "Rating" : "Team"}
            onChange={handleChangeSelect}
          >
            {ratings
              ? Object.entries(RatingTypes).map(([key, value]) => (
                  <MenuItem value={value} key={key}>
                    {key}
                  </MenuItem>
                ))
              : teams.map((teamItem, index) => (
                  <MenuItem value={teamItem.scoreableId} key={index}>
                    {teamItem.displayName}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={handleSaveRatings}
          >
            Save Ratings
          </Button>
        </FormControl>
      </Box>
    </Card>
  );
}
